@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Alert {
  @extend %font-family-primary;

  padding: 7px 12px;
  border-radius: 4px;
  font-size: $font-size-normal;
  color: $theme-color-text;

  > * {
    margin: 0;
  }

  &.default {
    background-color: $color-highlight-blue;
  }

  &.success {
    background-color: $color-secondary-green-10;
  }

  &.none {
    background-color: $color-input-readonly;
  }

  &.information {
    background-color: $theme-information-background-color;
  }

  strong {
    font-weight: $font-weight-semibold;
  }
}